export default {
  user: {
    statistics: {},
  },
  statistics: {},
};
